import { editorPick } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function EditorLinks() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-12">
        <SectionHeading index="04" title="栏目速递" note="错过不迷路，按专题挑着看" onMore={() => {}} />
        <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {editorPick.map((col, c) => (
            <div key={c} className="rounded-lg border border-background-200 p-4 md:p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i
                  className={`${
                    c === 0
                      ? "ri-lock-2-line text-primary-500"
                      : c === 1
                        ? "ri-chat-voice-line text-accent-600"
                        : "ri-git-merge-line text-secondary-700"
                  }`}
                />
                {col.col}
              </h3>
              <ul className="mt-3 flex flex-col divide-y divide-background-200">
                {col.items.map((t, i) => (
                  <li key={i}>
                    <a
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      className="group flex cursor-pointer items-start gap-2 py-2.5 text-sm leading-snug text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      <i className="mt-1 text-xs text-primary-300 transition-colors group-hover:text-primary-500 ri-arrow-right-s-line" />
                      {t}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}